import React, { createContext, useContext, useState, useEffect } from 'react';
import localforage from 'localforage';

const AuthContext = createContext();

export const useAuth = () => {
    return useContext(AuthContext);
};

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadUser = async () => {
            try {
                const userStore = localforage.createInstance({ name: 'users' });
                const currentUser = await userStore.getItem('currentUser');
                if (currentUser) {
                    setUser(currentUser);
                }
            } catch (error) {
                console.error('Error loading user:', error);
            } finally {
                setLoading(false);
            }
        };

        loadUser();
    }, []);

    // --- UPDATED LOGIN FUNCTION: SEARCH BY USERNAME, VERIFY HASHED PASSWORD ---
    const login = async (username, password) => {
        try {
            const userStore = localforage.createInstance({ name: 'users' });
            const keys = await userStore.keys();
            const users = await Promise.all(keys.map(key => userStore.getItem(key)));
            const user = users.find(u => u && u.username === username);
            if (!user) {
                return { success: false, message: 'Invalid credentials' };
            }
            // Use verifyPassword to compare hashes
            const { verifyPassword } = await import('../utils/browserSecurity');
            const passwordValid = await verifyPassword(password, user.password);
            if (!passwordValid) {
                return { success: false, message: 'Invalid credentials' };
            }
            await userStore.setItem('currentUser', user);
            setUser(user);
            return { success: true };
        } catch (error) {
            console.error('Login error:', error);
            return { success: false, message: error.message };
        }
    };
    // --- END UPDATED LOGIN FUNCTION ---

    const logout = async () => {
        try {
            const userStore = localforage.createInstance({ name: 'users' });
            await userStore.removeItem('currentUser');
            setUser(null);
            return { success: true };
        } catch (error) {
            console.error('Logout error:', error);
            return { success: false, message: error.message };
        }
    };

    const value = {
        user,
        login,
        logout,
        loading
    };

    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export default AuthContext; 